import gql from 'graphql-tag';

export default gql`
  mutation resetPassword ($input: ResetPasswordInput!) {
    resetPassword(input: $input)
  }
`;
